import Emyra_Maza from "assets/images/Emyra_Maza.png";
import link_to_google_play from "assets/images/link_to_google_play.jpg";
import link_to_apple_store from "assets/images/link_to_apple_store.jpg";
import alrajhi_bank_app from "assets/images/alrajhi_bank_app.png";
import { Modal } from "react-bootstrap";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import TabContext from "context/TabContext";

const GOOGLE_PLAY_LINK =
  "https://play.google.com/store/apps/details?id=com.alrajhibank.mobile";
const APP_STORE_LINK =
  "https://apps.apple.com/us/app/alrajhi-24seven-malaysia/id1460107576?ls=1";

function Hero({ sectionHeight }) {
  const [showDownload, setShowDownload] = useState(false);

  // const handleGetApp = () => {
  //   if (isIOS) {
  //     return window.open(APP_STORE_LINK);
  //   }

  //   if (isAndroid) {
  //     return window.open(GOOGLE_PLAY_LINK);
  //   }

  //   setShowDownload(true);
  // };
  return (
    <>
      <Modal show={showDownload} onHide={() => setShowDownload(false)} centered>
        <Modal.Header closeButton style={{ alignItems: "start" }}>
          <Modal.Title>
            <div className="get-app-header">
              Download the{" "}
              <span className="primary-color">alrajhi@24/seven</span> app now!
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img src={alrajhi_bank_app} width="25%" alt="alrajhi_bank_app" />
          <div className="d-flex flex-column gap-4 p-3 pt-4">
            <img
              src={link_to_google_play}
              width="100%"
              alt="link_to_google_play"
              onClick={() => window.open(GOOGLE_PLAY_LINK)}
              className="cursor-pointer"
            />
            <img
              src={link_to_apple_store}
              width="100%"
              alt="link_to_apple_store"
              onClick={() => window.open(APP_STORE_LINK)}
              className="cursor-pointer"
            />
          </div>
        </Modal.Body>
      </Modal>
      <section
        className="section hero"
        style={{ height: `calc(100vh - (150px + ${sectionHeight}px))` }}
      >
        <div className="container">
          <div className="text-center">
            <div
              className="hero-title mt-4"
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              Islamic Finance, Innovative Solutions
            </div>
            {/* <div
              className="hero-subtitle"
              data-aos="zoom-in"
              data-aos-duration="1100"
            >
              The Same Trusted Shariah-Compliant Banking.
            </div> */}
            {/* <div className="py-3 position-relative"style={{ zIndex: '99' }}>
              <PrimaryButton text="Get the app" onClick={handleGetApp} />
            </div> */}
            <img
              src={Emyra_Maza}
              className="image"
              alt="hero-image"
              data-aos="zoom-in-up"
              data-aos-duration="1000"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
